import { ActionContext, Module } from "vuex";
import { RootState } from "@/store/index";
import { User, userApi } from "@/api/users";

export interface UserState {
  users: User[];
  activeUsers: User[];
}

const userModule: Module<UserState, RootState> = {
  namespaced: true,
  state: () =>
    ({
      users: [] as User[],
    } as UserState),
  mutations: {
    setAllUsers(state: UserState, users: User[]) {
      state.users = users.sort((a: User, b: User) =>
        a.username.localeCompare(b.username)
      );
      state.activeUsers = state.users.filter(u => !u.disabled)
    },
  },
  getters: {
    filteredByUser: (state: UserState) => (user: User) => {
      return state.users
        .filter((u) => {
          return u.id?.toString() !== user.id?.toString();
        })
        .sort((a: User, b: User) => a.username.localeCompare(b.username));
    },
  },
  actions: {
    async loadAllUsersAsync(context: ActionContext<UserState, RootState>) {
      context.commit("setAllUsers", await userApi.list());
    },
    async addUser(context: ActionContext<UserState, RootState>, user: User) {
      user.id = await userApi.add(user);
      context.commit("setAllUsers", await userApi.list());
    },
    async editUser(context: ActionContext<UserState, RootState>, user: User) {
      if (user.id) {
        await userApi.edit(user.id, user);
        context.commit("setAllUsers", await userApi.list());
      }
    },
    async removeUser(context: ActionContext<UserState, RootState>, user: User) {
      if (user.id) {
        await userApi.delete(user.id);
        context.commit("setAllUsers", await userApi.list());
      }
    },
  },
};

export default userModule;
